export function navHTML(right?: string): string {
  return `
    <nav class="nav">
      <a href="#/" class="logo-text" aria-label="StonkRider — home"><span>STONK</span><span>RIDER</span></a>
      ${right !== undefined ? right : `
      <div class="nav-links">
        <a href="#/leaderboard">Leaderboard</a>
        <a href="#/about">About</a>
      </div>`}
    </nav>
  `;
}
